var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRedirect = function SvgRedirect(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 9.3 8.4",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 4.2c-.2 0-.4.2-.5.4v.1C8.4 5.4 7.8 6 7 6H1.6l.6-.6c.2-.2.2-.5 0-.7s-.5-.2-.7 0L.1 6.2l-.1.1v.4s0 .1.1.1l1.4 1.4c.2.2.5.2.6 0 .2-.2.2-.5 0-.6L1.6 7H7c1.3 0 2.3-1 2.3-2.3 0-.3-.2-.5-.5-.5.1 0 0 0 0 0m.4-2.5s0-.1-.1-.1L7.8.1c-.2-.1-.5-.1-.7 0-.2.2-.2.5 0 .6l.6.6H2.3C1.1 1.4 0 2.4 0 3.7c0 .3.2.5.4.5h.1c.2 0 .4-.2.5-.4v-.1c0-.8.6-1.4 1.3-1.4h5.4l-.6.6c-.2.2-.2.5 0 .7s.5.2.6 0l1.4-1.4.1-.1c0-.1.1-.1 0-.2.1-.1.1-.2 0-.2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRedirect);
export default ForwardRef;